import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=acaf4ee4&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acaf4ee4')) {
      api.createRecord('acaf4ee4', component.options)
    } else {
      api.reload('acaf4ee4', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=acaf4ee4&", function () {
      api.rerender('acaf4ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HDnQ7pWvh0SR/JS/ImageCarousel.vue"
export default component.exports